/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsplatformsection2Inputs */

const en_statsplatformsection2 = /** @type {(inputs: Statsplatformsection2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

const de_statsplatformsection2 = /** @type {(inputs: Statsplatformsection2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattform`)
};

/**
* | output |
* | --- |
* | "Platform" |
*
* @param {Statsplatformsection2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsplatformsection2 = /** @type {((inputs?: Statsplatformsection2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsplatformsection2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsplatformsection2(inputs)
	return de_statsplatformsection2(inputs)
});
export { statsplatformsection2 as "statsPlatformSection" }